import React from 'react';

export default function NoSelectWrapper(props: any) {
  return (
      <div className={'noselect'}>
          {props.children}
      </div>
  );
}
